// extracted by mini-css-extract-plugin
module.exports = {"text":"ProjectHelpPage1_text__35OFk","imageArrow":"ProjectHelpPage1_imageArrow__1mAI0"};